import React from 'react';
import { IonAlert } from '@ionic/react';
import { ALERT_BUTTON_ROLES } from '../../utils/constants';
import { useTranslation } from "react-i18next";

export const PermissionAlert = (props: any) => {
    const { t } = useTranslation();
    return (
        <>
            <IonAlert
                data-testid="alert"
                isOpen={props.isOpen}
                message={props.message}
                backdropDismiss={false}
                header={props.title}
                buttons={
                    [
                        {
                            text: t('Ok_TEXT'),
                            role: ALERT_BUTTON_ROLES.ok,
                            cssClass: 'secondary',
                            handler: () => { props.close() }
                        }
                    ]
                } />

        </>
    )
}
